import { Component, ElementRef, Renderer2 } from '@angular/core';
import { Menu, NavService } from '../../../services/nav.service';
import { ProfileService, UserProfile } from '../../../services/profile.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { LanguageSwitcherComponent } from '../language-switcher/language-switcher.component';
import { AuthService } from '../../../services/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CapitalizePipe, UppercasePipe } from '../../../pipes/text-pipes';

interface Item {
  id: number;
  name: string;
  type: string;
  title: string;
  // Adicione outras propriedades conforme necessário
}

@Component({
  standalone: true,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [CommonModule, FormsModule, RouterModule, LanguageSwitcherComponent, TranslateModule, CapitalizePipe, UppercasePipe],
})
export class HeaderComponent {
  /**
   * Dados do perfil do usuário autenticado
   */
  profile!: UserProfile;

  cartItemCount: number = 5;
  notificationCount: number = 5;
  public isCollapsed = true;

  constructor(
    public navServices: NavService, 
    private elementRef: ElementRef, 
    private renderer: Renderer2, 
    private profileService: ProfileService,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {}

  isFullScreen = false;
  fullScreenIconVisible = true;
  exitFullScreenIconVisible = false;

  toggleFullScreen() {
    this.isFullScreen = !this.isFullScreen;
    this.fullScreenIconVisible = !this.isFullScreen;
    this.exitFullScreenIconVisible = this.isFullScreen;
  }

  themeChange(type: string, type1: string, type2: string) {
    this.elementRef.nativeElement.ownerDocument.documentElement?.setAttribute('class', type);
    this.elementRef.nativeElement.ownerDocument.documentElement?.setAttribute('style', '');
    localStorage.removeItem('ynex-background-mode-body');
    localStorage.removeItem('ynex-background-mode-dark');
    localStorage.setItem('ynex-theme-mode', type);
    this.elementRef.nativeElement.ownerDocument.documentElement?.setAttribute('data-header-styles', type1);
    localStorage.setItem('ynex-header-mode', type1);
    this.elementRef.nativeElement.ownerDocument.documentElement?.setAttribute('data-menu-styles', type2);
    localStorage.setItem('ynex-menu-mode', type2);
    const htmlElement = this.elementRef.nativeElement.ownerDocument.documentElement;

    if (type == 'dark') {
      const darkbtn = document.querySelector('#switcher-dark-theme') as HTMLInputElement;
      darkbtn.checked = true;
      this.renderer.setAttribute(htmlElement, 'data-menu-style', 'dark');
    } else {
      const lightbtn = document.querySelector('#switcher-light-theme') as HTMLInputElement;
      lightbtn.checked = true;
      this.renderer.setAttribute(htmlElement, 'data-menu-style', 'light');
    }
  }

  toggleSidebar() {
    let html = this.elementRef.nativeElement.ownerDocument.documentElement;
    // const windowObject: any = window;
    if (localStorage.getItem('data-toggled') == 'true') {
      document.querySelector('html')?.getAttribute('data-toggled') == 'icon-overlay-close';
    } else if (html?.getAttribute('data-vertical-style') == 'overlay') {
      document.querySelector('html')?.getAttribute('data-toggled') != null
        ? document.querySelector('html')?.removeAttribute('data-toggled')
        : document.querySelector('html')?.setAttribute('data-toggled', 'icon-overlay-close');
    } else if (localStorage.getItem('ynex-sidemenu-styles') == 'closed') {
      html?.setAttribute('data-toggled', html?.getAttribute('data-toggled') == 'close-menu-close' ? '' : 'close-menu-close');
    } else if (localStorage.getItem('ynex-sidemenu-styles') == 'icontext') {
      html?.setAttribute('data-toggled', html?.getAttribute('data-toggled') == 'icon-text-close' ? '' : 'icon-text-close');
    } else if (localStorage.getItem('ynex-sidemenu-styles') == 'detached') {
      html?.setAttribute('data-toggled', html?.getAttribute('data-toggled') == 'detached-close' ? '' : 'detached-close');
    } else if (localStorage.getItem('ynex-sidemenu-styles') == 'doublemenu') {
      html?.setAttribute('data-toggled', html?.getAttribute('data-toggled') == 'double-menu-close' ? 'double-menu-open' : 'double-menu-close');

      // document.querySelector('.slide-menu')?.classList.add('double-menu-active');
    }

    if (window.innerWidth <= 992) {
      html?.setAttribute('data-toggled', html?.getAttribute('data-toggled') == 'open' ? 'close' : 'open');
      if (html?.getAttribute('data-toggled') == 'open') {
        document.querySelector('#responsive-overlay')?.classList.add('active');
      }
    }
  }

  // Search
  public menuItems!: Menu[];
  public items!: Menu[];
  public text!: string;
  public SearchResultEmpty: boolean = false;

  ngOnInit() {
    this.navServices.items.subscribe((menuItems) => {
      this.items = menuItems;
    });

    this.loadUserProfile();
  }

  /**
   * Requisição à API para buscar os dados do usuário autenticado
   */
  private loadUserProfile(): void {
    this.profileService.getProfile().subscribe({
      next: (res) => {
        this.profile = res.data;
      },
      error: (err) => {
        console.error('Erro ao carregar perfil:', err);
      },
    });
  }

  get avatarImageUrl(): string {
    if (!this.profile) return './assets/img/people-1.jpg';
    const avatarUrl = this.profile.avatarUrl;
    
    // Verifica se avatarUrl é válido
    if (!avatarUrl || 
        avatarUrl === 'null' || 
        avatarUrl === null ||
        (typeof avatarUrl === 'string' && avatarUrl.trim() === '') ||
        (typeof avatarUrl === 'string' && avatarUrl.includes('404'))) {
      return './assets/img/people-1.jpg';
    }
    
    return avatarUrl;
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    if (img) {
      img.src = './assets/img/people-1.jpg';
    }
  }

  Search(searchText: string) {
    if (!searchText) return (this.menuItems = []);
    // items array which stores the elements
    const items: Item[] = [];
    // Converting the text to lower case by using toLowerCase() and trim() used to remove the spaces from starting and ending
    searchText = searchText.toLowerCase().trim();
    this.items.filter((menuItems: Menu) => {
      // checking whether menuItems having title property, if there was no title property it will return
      if (!menuItems?.title) return false;
      //  checking wheteher menuitems type is text or string and checking the titles of menuitems
      if (menuItems.type === 'link' && menuItems.title.toLowerCase().includes(searchText)) {
        // Converting the menuitems title to lowercase and checking whether title is starting with same text of searchText
        if (menuItems.title.toLowerCase().startsWith(searchText)) {
          // If you want to get all the data with matching to letter entered remove this line(condition and leave items.push(menuItems))
          // If both are matching then the code is pushed to items array
          items.push(menuItems as Item);
        }
      }
      //  checking whether the menuItems having children property or not if there was no children the return
      if (!menuItems.children) return false;
      menuItems.children.filter((subItems: Menu) => {
        if (!subItems?.title) return false;
        if (subItems.type === 'link' && subItems.title.toLowerCase().includes(searchText)) {
          if (subItems.title.toLowerCase().startsWith(searchText)) {
            // If you want to get all the data with matching to letter entered remove this line(condition and leave items.push(subItems))
            items.push(subItems as Item);
          }
        }
        if (!subItems.children) return false;
        subItems.children.filter((subSubItems: Menu) => {
          if (subSubItems.title?.toLowerCase().includes(searchText)) {
            if (subSubItems.title.toLowerCase().startsWith(searchText)) {
              // If you want to get all the data with matching to letter entered remove this line(condition and leave items.push(subSubItems))
              items.push(subSubItems as Item);
            }
          }
        });
        return true;
      });
      return (this.menuItems = items);
    });
    // Used to show the No search result found box if the length of the items is 0
    if (!items.length) {
      this.SearchResultEmpty = true;
    } else {
      this.SearchResultEmpty = false;
    }
    return true;
  }

  //  Used to clear previous search result
  clearSearch() {
    this.text = '';
    this.menuItems = [];
    this.SearchResultEmpty = false;
    return this.text, this.menuItems;
  }

  isCartEmpty: boolean = false;
  isNotifyEmpty: boolean = false;

  removeRow(rowId: string) {
    const rowElement = document.getElementById(rowId);
    if (rowElement) {
      rowElement.remove();
    }
    this.cartItemCount--;
    this.isCartEmpty = this.cartItemCount === 0;
  }

  removeTags(rowId: string) {
    const rowElement = document.getElementById(rowId);
    if (rowElement) {
      rowElement.remove();
    }
  }

  removeNotify(rowId: string) {
    const rowElement = document.getElementById(rowId);
    if (rowElement) {
      rowElement.remove();
    }
    this.notificationCount--;
    this.isNotifyEmpty = this.notificationCount === 0;
  }

  handleCardClick(event: MouseEvent) {
    // Prevent the click event from propagating to the container
    event.stopPropagation();
  }

  logout(): void {
    // Salva os valores das chaves que devem ser mantidas
    const rememberedEmail = localStorage.getItem('rememberedEmail');
    const lang = localStorage.getItem('lang');

    // Limpa todo o localStorage
    localStorage.clear();

    // Restaura as chaves que devem ser mantidas
    if (rememberedEmail !== null) {
      localStorage.setItem('rememberedEmail', rememberedEmail);
    }
    if (lang !== null) {
      localStorage.setItem('lang', lang);
    }

    // Limpa todo o sessionStorage
    sessionStorage.clear();

    // Limpa todos os caches do Cache Storage (PWA/Service Worker)
    if ('caches' in window) {
      caches.keys().then(function(names) {
        for (let name of names) caches.delete(name);
      });
    }

    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(['/auth/login']);
        console.log('Logout successful');
      },
      error: () => {
        this.router.navigate(['/auth/login']);
        console.error('Logout failed');
      }
    });
  }
}
